// extracted by mini-css-extract-plugin
export default {"icon":"nA7fW","text":"stGp+","button":"PemNE"};